const Appointment = "https://drinkcoach.bookinglive.com/";
const Pdf = "/static/Barnet-Enfield-Haringey-Special-Services.pdf";
const AppStore = "https://itunes.apple.com/gb/app/drinkcoach+/id849022698?mt=8&ign-mpt=uo%3D4";
const PlayStore = "https://play.google.com/store/apps/details?id=com.td.drinkcoach";
export default {
    AppStore,
    PlayStore,
    Appointment,
    Pdf
};
//# sourceMappingURL=Urls.js.map